<form
  class="my-0"
  [class.compact]="compact()"
  [formGroup]="loginForm"
  (ngSubmit)="onLoginFormSubmit()"
>
  @if (loginStep() === 'credentials') {
    <div class="form-group" [class.invalid]="email.invalid && loginFormSubmitAttempt()">
      <input
        class="form-control"
        type="email"
        [placeholder]="'jobboard.platform.auth.login.form.email' | transloco"
        [formControl]="email"
        autocomplete="email"
      />
      <div class="validation">
        @if (email.errors?.['required']) {
          <p>{{ 'ct-library.validation.required' | transloco }}</p>
        }
        @if (email.errors?.['email'] || email.errors?.['pattern']) {
          <p>{{ 'ct-library.validation.email' | transloco }}</p>
        }
      </div>
    </div>
    <div class="form-group" [class.invalid]="password.invalid && loginFormSubmitAttempt()">
      <input
        class="form-control"
        type="password"
        appPasswordEye
        [placeholder]="'jobboard.platform.auth.login.form.password' | transloco"
        [formControl]="password"
        autocomplete="current-password"
      />
      <div class="validation">
        @if (password.errors?.['required']) {
          <p>{{ 'ct-library.validation.required' | transloco }}</p>
        }
        @if (password.errors?.['minlength']) {
          <p>{{ 'ct-library.validation.minlength' | transloco }}</p>
        }
      </div>
    </div>
    <div class="login-meta">
      <div class="form-group remember-me">
        <div class="d-flex align-items-center gap-2">
          <input
            class="form-control my-0"
            type="checkbox"
            id="platform-remember-me"
            formControlName="rememberMe"
          />
          <label for="platform-remember-me">
            <p>{{ 'jobboard.platform.auth.login.form.remember-me' | transloco }}</p>
          </label>
        </div>
      </div>
      @if (!compact()) {
        <p class="text-end password-reset-link mb-0">
          <a
            href="#"
            (click)="$event.preventDefault(); forgotPassword.emit()"
            (keydown.enter)="$event.preventDefault(); forgotPassword.emit()"
          >
            {{ 'jobboard.platform.auth.login.forgot-btn' | transloco }}
          </a>
        </p>
      }
    </div>
  } @else {
    <div class="totp-step">
      <p class="totp-info">{{ 'jobboard.platform.auth.login.form.totp-info' | transloco }}</p>
      @if (totpInvalid()) {
        <div class="ct-alert">
          <span>{{ 'jobboard.platform.settings.tfa.wrong-code' | transloco }}</span>
        </div>
      }
      <div class="totp-otp-wrap" [class.ct-totp-invalid]="totpInvalid()">
        <p-inputOtp
          [length]="6"
          [integerOnly]="true"
          [mask]="false"
          [autofocus]="true"
          styleClass="ct-totp-input"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="totpCode"
          (onChange)="onOtpChange($event)"
        ></p-inputOtp>
      </div>
      <p class="totp-help" [innerHTML]="'jobboard.platform.settings.tfa.lost-help' | transloco"></p>
    </div>
  }
  <app-button
    variant="primary"
    htmlType="submit"
    [disabled]="cooldown() > 0 || (loginStep() === 'totp' && totpCode.toString().length !== 6)"
    [loading]="loading() || loginAttempt()"
    [disableOnNoConnection]="true"
    [fullWidth]="true"
  >
    {{ 'jobboard.platform.auth.login.form.submit-btn' | transloco }}
    @if (cooldown() > 0) {
      <span class="cooldown">({{ cooldown() }}s)</span>
    }
  </app-button>
  @if (loginStep() === 'totp') {
    <p class="password-reset-link mb-2 totp-back-under">
      <a
        href="#"
        (click)="$event.preventDefault(); goBackToCredentials()"
        (keydown.enter)="$event.preventDefault(); goBackToCredentials()"
        (keydown.space)="$event.preventDefault(); goBackToCredentials()"
      >
        {{ 'jobboard.platform.auth.login.form.back-btn' | transloco }}
      </a>
    </p>
  }
  @if (compact() && loginStep() === 'credentials') {
    <p class="text-end password-reset-link mt-2 mb-0">
      <a
        href="#"
        (click)="$event.preventDefault(); forgotPassword.emit()"
        (keydown.enter)="$event.preventDefault(); forgotPassword.emit()"
      >
        {{ 'jobboard.platform.auth.login.forgot-btn' | transloco }}
      </a>
    </p>
  }
</form>
